export enum Urls {
  Halls = "/halls",
  AvailableSlots = "/halls/:hallId/slots",
  AvailableDates = "/halls/:hallId/dates",
  Equipment = "/booking/equipment/available",
  EquipmentKits = "/booking/equipment/defaults",
  PaymentMethods = "/booking/payment/methods",
  Booking = "/booking",
  Clients = "/booking/clients",
  Users = "/",

  ClientById = "/booking/client/:id",

  PromoCode = "/booking/validate/promocode",
  BookingPrice = "/booking/:bookingId/price",
  PriceHistory = "/booking/:bookingId/price-history",
  BookingById = "/booking/:bookingId",
  BookingPay = "/booking/:bookingId/pay",
  Notifications = "/booking/notifications",

  CheckIn = "/check-in",
  CheckInStatus = "/checked-in",
  Login = "/user/login",
  Outcome = "/reports/add/outcome",
  BonusStatistics = "/reports/statistics/bonuses",
  FullClients = "/clients",
}
